import { Campaign } from 'domains/campaigns/types';
import { useAccessCentrePermissions } from 'hooks/useAccessCentrePermissions';
import { CampaignStatus } from 'models/enums';

import PendingWinnerSelectionStatus from './StatusComponents/PendingWinnerSelectionStatus';
import SendingTestStatus from './StatusComponents/SendingTestStatus';
import SendingWinnerStatus from './StatusComponents/SendingWinnerStatus';
import WinnerDeclaredStatus from './StatusComponents/WinnerDeclaredStatus';
import WinnerFailedStatus from './StatusComponents/WinnerFailedStatus';
import WinnerScheduledStatus from './StatusComponents/WinnerScheduledStatus';
import WinnerSentStatus from './StatusComponents/WinnerSentStatus';
import WinnerStoppedStatus from './StatusComponents/WinnerStoppedStatus';

type AbTestingStatusDetailsProps = {
    campaign: Campaign;
    contentPreviewNodeId?: string | number;
    handlePreviewClick: (contentNodeId: number) => void;
};

const AbTestingStatusDetails = ({
    campaign,
    contentPreviewNodeId,
    handlePreviewClick,
}: AbTestingStatusDetailsProps) => {
    const { canCurationsAbTesting } = useAccessCentrePermissions();

    // Only render if campaign has AB test configuration
    if (!campaign.abTestConfig) {
        return null;
    }

    // Route to the appropriate status component
    switch (campaign.status) {
        case CampaignStatus.SENDING:
        case CampaignStatus.SENDING_AB_TEST:
            return <SendingTestStatus campaign={campaign} />;
        case CampaignStatus.PENDING_WINNER_SELECTION:
            if (!canCurationsAbTesting) return null;
            return <PendingWinnerSelectionStatus campaign={campaign} />;
        case CampaignStatus.SCHEDULED:
            return null;
        case CampaignStatus.COMPLETED:
            if (!canCurationsAbTesting) return null;
            return <PendingWinnerSelectionStatus campaign={campaign} />;
        case CampaignStatus.WINNER_DECLARED:
            if (!canCurationsAbTesting) return null;
            return <WinnerDeclaredStatus campaign={campaign} />;
        case CampaignStatus.WINNER_SCHEDULED:
            if (!canCurationsAbTesting) return null;
            return <WinnerScheduledStatus campaign={campaign} />;
        case CampaignStatus.SENDING_WINNER:
            return <SendingWinnerStatus campaign={campaign} />;
        case CampaignStatus.WINNER_SENT:
            if (!canCurationsAbTesting) return null;
            return <WinnerSentStatus campaign={campaign} />;
        case CampaignStatus.WINNER_FAILED:
            return <WinnerFailedStatus campaign={campaign} />;
        case CampaignStatus.WINNER_STOPPED:
            return <WinnerStoppedStatus campaign={campaign} />;
        case CampaignStatus.FAILED:
            // Regular campaign failure, not AB test specific
            return null;
        default:
            return null;
    }
};

export default AbTestingStatusDetails;
